// Helper function
const grecaptcha = window.grecaptcha;

let domReady = (cb) => {
    document.readyState === 'interactive' || document.readyState === 'complete'
        ? cb()
        : document.addEventListener('DOMContentLoaded', cb);
};

domReady(() => {
    // Display body when DOM is loaded
    document.body.style.visibility = 'visible';
});

/**
 * Scroll down
 */
// Seleziona l'elemento della freccia
const scrollChevron = document.getElementById('chevron');

// Verifica che l'elemento esista
if (scrollChevron) {

    // Sposta e posiziona la freccia in fondo a .wrapper-header
    const wrapperHeader = document.querySelector('.wrapper-header');
    if (wrapperHeader) {
        // Assicura che il wrapper possa contenere posizionamenti assoluti
        const computedPos = window.getComputedStyle(wrapperHeader).position;
        if (computedPos === 'static' || !computedPos) {
            wrapperHeader.style.position = 'relative';
        }
        // Appendi la freccia alla fine del wrapper, se non è già lì
        if (scrollChevron.parentElement !== wrapperHeader) {
            wrapperHeader.appendChild(scrollChevron);
        }
        // Posiziona la freccia sempre in fondo e centrata, senza uscire dal div
        scrollChevron.style.position = 'absolute';
        scrollChevron.style.left = '50%';
        scrollChevron.style.bottom = '56px';
        scrollChevron.style.transform = 'translateX(-50%)';
        scrollChevron.style.zIndex = '10';
        scrollChevron.style.maxWidth = '100%';
        scrollChevron.style.boxSizing = 'border-box';
    }

    // Aggiungi il comportamento al click sulla freccia (scroll e poi nascondi)
    scrollChevron.addEventListener('click', () => {
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        });
        scrollChevron.classList.add('hidden');
    });

    // Mostra/nasconde la freccia quando l'utente fa scroll
    const toggleChevronOnScroll = () => {
        if (window.scrollY < 50) {
            scrollChevron.classList.remove('hidden');
        } else {
            scrollChevron.classList.add('hidden');
        }
    };
    window.addEventListener('scroll', toggleChevronOnScroll);
    // Valuta lo stato iniziale
    toggleChevronOnScroll();
}

/**
 * Cookie
 */

(function($) {
    // Funzione per impostare un cookie
    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    // Funzione per ottenere un cookie
    function getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }

        }
        return null;
    }

    // Verificare se il consenso è già stato dato
    $(document).ready(function() {
        if (!getCookie('cookieConsent')) {
            $('#cookie-banner').show();
        }

        // Click sul pulsante "Accetta tutti"
        $('#cookie-accept-all').on('click', function() {
            setCookie('cookieConsent', 'all', 365);
            $('#cookie-banner').hide();
        });

        // Click sul pulsante "Solo necessari"
        $('#cookie-accept-necessary').on('click', function() {
            setCookie('cookieConsent', 'necessary', 365);
            $('#cookie-banner').hide();
        });
    });
})(jQuery);

// search header
(function ($) {

    $(function () {
        setupSearch();
    });

    function setupSearch() {

        let input = $(".search").find(".input-group input");

        input.keyup(function (e) {
            if (e.which === 13) {
                let term = encodeURIComponent(input.val().trim());
                document.location.href = "/search?k=" + term;
            }
        })

        $( ".btn-search" ).on( "click", function(e) {
            let term = encodeURIComponent(input.val().trim());
            document.location.href = "/search?k=" + term;
        });

    }

})(jQuery);

/**
Hamburgers
 */

$("#btn-hamburger").on("click", function () {

    // $("#btn-hamburger-sticky").toggleClass("is-active");

    $('.bg-cover').toggleClass('reveal');

    $(this).toggleClass("is-active");

    $("#header-collapse").toggleClass("open");

    $("#hamburger").toggleClass("open");
});

// $("#btn-hamburger-sticky").on("click", function () {
//
//     $(this).toggleClass("is-active");
//
//     $('.bg-cover').toggleClass('reveal');
//
//     $(this).css({"display":"none"});
//
//     $("#btn-hamburger").removeAttr("style");
//
//     $("#header-collapse").toggleClass("open");
// });

$('.bg-cover').on("click", function(){
    $('.bg-cover').toggleClass('reveal');
    // $("#btn-hamburger-sticky").toggleClass("is-active");
    $("#btn-hamburger").toggleClass("is-active");
    $("#header-collapse").toggleClass("open");
})

$('#header-collapse').on("click", function(event){
    event.stopPropagation();
});

// $("#btn-hamburger").click(function() {
//
//     $(this).toggleClass("is-active");
//
//     $("#header-collapse").toggleClass("open");
//
//
// });

/**
 * Sticky Header
 */

// $(document).ready(function(){
//     $(window).trigger('scroll');
//     $(window).bind('scroll', function () {
//         let pixels = 200; //number of pixels before modifying styles
//         if ($(window).scrollTop() > pixels) {
//
//             $("#header").addClass('sticky').css({"background-color":"rgba(35, 47, 89, .9)", "position":"fixed"});
//
//             $("#logo").removeClass('logo').addClass('logo-sticky');
//
//             $("#btn-contact").removeClass('btn-contact').addClass('btn-contact-sticky');
//
//             $("#hamburger").addClass("btn-hamburger-sticky");
//
//             // $("#btn-hamburger").addClass('btn-hamburger-sticky')
//             // $("#btn-hamburger").toggleClass("btn-hamburger-sticky");
//
//             // $("#btn-hamburger").css({"position":"fixed"});
//             //
//             // $(".hamburger-inner").css({"background-color":"black"});
//
//         } else {
//
//             $("#header").removeClass('sticky').removeAttr("style");
//
//             $("#hamburger").removeClass("btn-hamburger-sticky");
//
//             // $("#hamburger").toggleClass("btn-hamburger-sticky");
//
//             // $("#btn-hamburger").css({"position":"absolute"});
//             //
//             // $(".hamburger-inner").css({"background-color":"white"});
//
//             // $("#header").removeClass('sticky').css({"background-color": "rgba(0, 0, 0, 1)", "position":"absolute"});
//
//             $("#logo").removeClass('logo-sticky').addClass('logo');
//
//             $("#btn-contact").removeClass('btn-contact-sticky').addClass('btn-contact');
//         }
//     });
// });

/**
 * Dropdown menu
 */

// $(document).ready(function() {
//
//     // $('#xl ul.nav li.dropdown').hover(function() {
//     //     $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
//     // }, function() {
//     //     $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
//     // });
//     // $('#xl ul.nav li.dropdown').hover(function(e) {
//     //     e.stopPropagation()
//     // });
//
//     $('#xl li.dropdown').hover(function() {
//         $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(100);
//         // $(this).css("background-color", "yellow");
//         $(this).addClass('marker');
//         // function(){$(this).removeClass('hover')}
//     }, function() {
//         $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(100);
//         $(this).removeClass('marker');
//     });
// });

/**
 * Scroll
 */

$(document).ready(function() {

    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    });

    $('.scrollup').click(function() {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

});

/**
 * Submit user
 */

$(document).ready(function(){

    $('textarea[name$="message"]').attr('maxlength','250');

    $('input[name$="email"]').keyup(function(){
        $(this).val($(this).val().toLowerCase());
    });

    $('input[name$="email_c"]').keyup(function(){
        $(this).val($(this).val().toLowerCase());
    });

    $('input[name$="phone"]').on('input', function (event) {
        this.value = this.value.replace(/[^0-9-+]/g, '');
    });

    $('input[name$="phone"]').attr('maxlength','16');


});

$(function() {
    const form = '#form_contact';
    $(form).submit(function(event) {
        event.preventDefault(); //Prevent the default form submission
        const recaptcha_site_key = $('.twig-js-var').data('recaptcha_site_key');
        grecaptcha.ready(function () {
            grecaptcha.execute(recaptcha_site_key, { action: 'submit' }).then(function (token) {
                const recaptchaResponse = document.getElementById('recaptchaResponse');
                recaptchaResponse.value = token;
                // Making the simple AJAX call to capture the data and submit
                $.ajax({
                    // url: '/test-contact-us',
                    type: 'post',
                    data: $(form).serialize(),
                    dataType: 'json',
                    success: function(response){
                        const error = response.error;
                        const success = response.success;
                        const url = response.url;
                        $('#user').modal('show');
                        if(error != "") {
                            $('#error_user').removeClass().addClass('error').html(error).fadeIn('slow');
                            // $('#alert_message').html(error);
                        }
                        else {
                            $('#error_user').removeClass().addClass('success').html(success).fadeIn('slow');
                            setTimeout(' window.location.href = "' + url + '";',5000);
                            // $('#alert_message').html(success);
                        }
                        setTimeout(function() {$('#user').modal('hide');}, 5000);
                    },
                    error: function(jqXhr, json, errorThrown){
                        var error = jqXhr.responseText;
                        $('#alert_message').html(error);
                    }
                });

            });
        });
    });
});

$(function() {

    var edit = 0;
    var form = '#form_user';
    var form_message = form + '-message';
    // en/disable submit button
    var disableSubmit = function(val){
        $(form + ' input[type=submit]').attr('disabled', val);
    };

    // setup loading message
    $(form).ajaxSend(function(){
        $(form_message).removeClass().addClass('loading').html('Loading...').fadeIn();
    });

    //hang on event of form with id=user
    $(form).submit(function(e) {

        //prevent Default functionality
        e.preventDefault();

        //get the action-url of the form
        var actionurl = e.currentTarget.action;

        var msg = '#error_user';

        // let url = $('.twig-js-var').data('homepage_url');

        let recaptcha_site_key = $('.twig-js-var').data('recaptcha_site_key');

        grecaptcha.ready(function () {
            grecaptcha.execute(recaptcha_site_key, { action: 'submit' }).then(function (token) {
                var recaptchaResponse = document.getElementById('recaptchaResponse');
                recaptchaResponse.value = token;
                // Making the simple AJAX call to capture the data and submit
                $.ajax({
                    // url: '/api.php?mode=user',
                    // url: actionurl,
                    type: 'post',
                    dataType: 'json',
                    data: $(form).serialize(),
                    beforeSend: function()
                    {
                        // $("#error").fadeOut();
                        // $("#btn-newsletter").html('<span class="glyphicon glyphicon-transfer"></span> &nbsp; sending ...');
                    },
                    success: function(json) {
                        // disableSubmit(true);
                        if(json.stato == 1) {
                            $( '#form_user' ).each(function(){
                                this.reset();
                            });

                            if (json.url) {
                                setTimeout(' window.location.href = "' + json.url + '";',5000);
                            }
                            else {
                                $('#user').modal('show');
                                $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow');
                                setTimeout(function() {$('#user').modal('hide');}, 5000);
                                $('#form_user').hide();
                                $('#abstract').hide();
                                $('#thankyou').show('slow');
                            }

                            // setTimeout('location.reload();',5000);
                        }
                        else {
                            $('#user').modal('show');
                            $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow');
                            setTimeout(function() {$('#user').modal('hide');}, 5000);
                        }
                    }
                });

            });
        });

        //do your own request an handle the results
        $.ajax({
            // url: '/api.php?mode=user',
            // url: actionurl,
            type: 'post',
            dataType: 'json',
            data: $(form).serialize(),
            beforeSend: function()
            {
                // $("#error").fadeOut();
                // $("#btn-newsletter").html('<span class="glyphicon glyphicon-transfer"></span> &nbsp; sending ...');
            },
            success: function(json) {
                // disableSubmit(true);
                if(json.stato == 1) {
                    $( '#form_user' ).each(function(){
                        this.reset();
                    });
                    $('#user').modal('show');
                    $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow');
                    setTimeout(function() {$('#user').modal('hide');}, 5000);
                    $('#form_user').hide();
                    // $('#thankyou').show('slow');

                    // if (json.url) {
                    //     setTimeout(' window.location.href = "' + json.url + '";',5000);
                    // }

                    // setTimeout('location.reload();',5000);
                }
                else {
                    $('#user').modal('show');
                    $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow');
                    setTimeout(function() {$('#user').modal('hide');}, 5000);
                }
            }
        });

        // grecaptcha.ready(function () {
        //
        //     grecaptcha.execute('6LcQsjEbAAAAAFN54__DNdd3G5AGF3EslhQrcR7J', { action: 'submit' }).then(function (token) {
        //
        //         var recaptchaResponse = document.getElementById('recaptchaResponse');
        //
        //         recaptchaResponse.value = token;
        //
        //         //get the action-url of the form
        //         var actionurl = '/user/';
        //         // var actionurl = e.currentTarget.action;
        //
        //         var msg = '#error_user';
        //
        //         //do your own request an handle the results
        //         $.ajax({
        //             url: actionurl,
        //             type: 'post',
        //             dataType: 'json',
        //             data: $(form).serialize(),
        //             beforeSend: function()
        //             {
        //                 // $('#error').fadeOut();
        //                 // $("#btn-newsletter").html('<span class="glyphicon glyphicon-transfer"></span> &nbsp; sending ...');
        //             },
        //             success: function(json) {
        //                 // disableSubmit(true);
        //                 if(json.stato == 1) {
        //                     // Delay pixel fire by 3 seconds
        //                     // setTimeout(function() {fbq('track', 'CompleteRegistration');}, 3000);
        //                     // $('.content-user').hide('');
        //                     $('#form_user').hide();
        //                     $('#title').hide();
        //                     $(msg).hide();
        //                     $('#thankyou').show('slow');
        //                     $('#btn-calendar').toggleClass("open");
        //
        //                     //check if gtag() function exists
        //                     if (typeof gtag === "function") {
        //                         // Trigger Analytics
        //                         gtag('event', 'btn_sign-up', {
        //                             'event_label': 'Registrazione evento',
        //                             'event_category': 'click',
        //                             'non_interaction': false
        //                         });
        //                     }
        //
        //                     // $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow').delay(8000).hide('slow');
        //                     //
        //                     // setTimeout(function(){
        //                     //     $(msg).slideUp('slow').fadeOut(function() {
        //                     //         // window.location.reload();
        //                     //         window.location = json.url;
        //                     //     });
        //                     // }, 3000);
        //
        //                     // setTimeout(window.location.reload(),8000);
        //
        //                     // setTimeout(function(){
        //                     //     $('#newsletter').slideUp('slow').fadeOut(function() {
        //                     //         // $(form).hide();
        //                     //         // $(form).clearForm();
        //                     //         window.location.reload();
        //                     //         // window.location = json.url;
        //                     //     });
        //                     // }, 8000);
        //
        //                     // window.location = json.url;
        //
        //                 }
        //                 else {
        //                     $('#user').modal('show');
        //                     $(msg).removeClass().addClass(json.type).html(json.message).fadeIn('slow');
        //                     setTimeout(function() {$('#user').modal('hide');}, 3000);
        //                 }
        //             }
        //         });
        //
        //     });
        //
        // });

    });

});

// /Submit user

/*
 * Light case
 */

// jQuery(document).ready(function($) {
//     $('a[data-rel^=lightcase]').lightcase({
//         showSequenceInfo: false,
//         showTitle: false
//     });
// });

/*
 * GLightbox
 */

const lightbox = GLightbox({
    selector: '.glightgallery',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
    onOpen: () => {
        console.log('Lightbox opened')
    },
    beforeSlideLoad: (slide, data) => {
        // Need to execute a script in the slide?
        // You can do that here...
    }
});
const lightboxVideo = GLightbox({
    selector: '.glightboxvideo',
});

/*
 * Lozad
 */

// const observer = lozad(); // lazy loads elements with default selector as '.lozad'
// observer.observe();

/**
 * Swiper
 */

// jQuery(function(){
//     jQuery('#showall').click(function(){
//         jQuery('.targetDiv').show();
//     });
//     jQuery('.app-year-inner').click(function(){
//         jQuery('.targetDiv').hide();
//         jQuery('#div'+$(this).attr('target')).show();
//     });
// });
//
// (function ($) {
//     "use strict";
//
//     $(function () {
//         // if (!$("html").hasClass("app-ourhistory-page")) return;
//
//         init();
//
//         $(window).on('resize', function () {
//             init();
//         });
//     })
//
//     let inited = false;
//     let desktop_inited = false;
//
//     function init() {
//
//         if (!inited) {
//             inited = true;
//             initAccordion();
//         }
//
//         // desktop specific
//         let is_desktop = true;
//
//         // let is_desktop = window.matchMedia("(min-width: 240px)").matches; // 1024
//         if (is_desktop && !desktop_inited) {
//             desktop_inited = true;
//             initDesktopNavigator();
//         }
//
//     }
//
//     function initAccordion() {
//
//         let container = $(".app-contents");
//         let anchors = container.find(".app-mob-picker a");
//
//
//         anchors.click(function (e) {
//
//             e.preventDefault();
//             e.stopPropagation();
//
//             let $this = $(this),
//                 li = $this.closest(".app-mob-picker");
//
//             // change baloon style
//             anchors.each(function () {
//                 $(this).closest(".app-mob-picker").removeClass("app-selected");
//             });
//             li.addClass("app-selected");
//
//             // show contents
//             showYearContents(li.data("year"));
//
//             // scroll contents up
//             $('html, body').animate({
//                 scrollTop: (li.offset().top - 40)
//             }, 400);
//
//         })
//
//     }
//
//     function initDesktopNavigator() {
//
//         let nav = $(".app-navigator"),
//             slides = nav.find(".app-year");
//
//         // init scroller
//         const swiper = new Swiper('.app-navigator-inner .swiper', {
//
//             slidesPerView: 9,
//             spaceBetween: 68,
//             // centeredSlides: true,
//
//             navigation: {
//                 nextEl: '.swiper-button-next',
//                 prevEl: '.swiper-button-prev',
//             },
//             breakpoints: {
//                 640: {
//                     slidesPerView: 3,
//                     spaceBetween: 20,
//                 },
//                 768: {
//                     slidesPerView: 4,
//                     spaceBetween: 40,
//                 },
//                 1024: {
//                     slidesPerView: 8,
//                     spaceBetween: 63,
//                 },
//             },
//         });
//
//         let slide = slides.first().find("a").closest(".app-year");
//         // let slide = slides.last().find("a").closest(".app-year");
//         slides.removeClass("app-active");
//         slide.addClass("app-active");
//
//         // move scroller
//         let index = slides.index(slide);
//         swiper.slideTo(index, 400, false);
//
//         // handle slide change
//         slides.on("click", "a", function (e) {
//             e.preventDefault();
//
//             // change button style
//             let slide = $(this).closest(".app-year");
//             slides.removeClass("app-active");
//             slide.addClass("app-active");
//
//             // move scroller
//             let index = slides.index(slide);
//             swiper.slideTo(index, 400, false);
//
//             // show contents
//             // let url = $(this).attr("href");
//             // window.location = url;
//
//             // showYearContents(slide.data("year"));
//
//         });
//
//         // preselect last slide
//         // slides.last().find("a").click();
//
//     }
//
//     function showYearContents(year) {
//
//         let years = $(".app-year-cont");
//
//         years.removeClass("app-active");
//
//         let selected = years.filter(function () {
//             return $(this).data("year") === year;
//         })
//
//         selected.addClass("app-active");
//
//     }
//
// })(jQuery);

const swiper = new Swiper('.wrapper-swiper .container-fluid .swiper', {
    preloadImages: false,
    // Enable lazy loading
    // lazy: true,
    // effect: "fade",
    // speed: 1000,
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    pagination: {
        el: ".wrapper-header .wrapper-swiper .container-fluid .swiper-pagination",
        // el: ".wrapper-header .wrapper-swiper .container-fluid .swiper .swiper-pagination",
        clickable: true,
    },
    mousewheel: false,
    keyboard: true,
});

const swiper_xl = new Swiper('.wrapper-swiper-xl .container-fluid .swiper', {
    preloadImages: false,
    // Enable lazy loading
    // lazy: true,
    // effect: "fade",
    // speed: 1000,
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    pagination: {
        el: ".wrapper-header .wrapper-swiper-xl .container-fluid .swiper-pagination",
        // el: ".wrapper-header .wrapper-swiper .container-fluid .swiper .swiper-pagination",
        clickable: true,
    },
    mousewheel: false,
    keyboard: true,
});

const swiper_xs = new Swiper('.wrapper-swiper-xs .container-fluid .swiper', {
    preloadImages: false,
    // Enable lazy loading
    // lazy: true,
    // effect: "fade",
    // speed: 1000,
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    pagination: {
        el: ".wrapper-header .wrapper-swiper-xs .container-fluid .swiper-pagination",
        // el: ".wrapper-header .wrapper-swiper .container-fluid .swiper .swiper-pagination",
        clickable: true,
    },
    mousewheel: false,
    keyboard: true,
});

const swiper_announcements = new Swiper('.content-hp-announcements-scholarships .container .swiper', {
    preloadImages: false,
    // Enable lazy loading
    // lazy: true,
    // effect: "fade",
    // speed: 1000,
    // slidesPerView: "auto",
    slidesPerView: 1,
    // spaceBetween: 30,
    // breakpoints: {
    //     320: {
    //         slidesPerView: 1,
    //         spaceBetween: 5,
    //     },
    //     640: {
    //         slidesPerView: 1,
    //         spaceBetween: 10,
    //     },
    //     768: {
    //         slidesPerView: 3,
    //         spaceBetween: 20,
    //     },
    //     1024: {
    //         slidesPerView: 3,
    //         spaceBetween: 20,
    //     },
    // },
    loop: true,
    // autoplay: {
    //     delay: 4000,
    //     disableOnInteraction: false,
    //     pauseOnMouseEnter: true,
    // },
    pagination: {
        el: ".swiper-pagination-announcements",
        clickable: true,
    },
    mousewheel: false,
    keyboard: true,
});

const swiper_news = new Swiper('.content-hp-news .container .content-row .swiper', {
    preloadImages: false,
    // Enable lazy loading
    // lazy: true,
    // effect: "fade",
    // speed: 1000,
    // slidesPerView: "auto",
    slidesPerView: 3,
    spaceBetween: 30,
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 5,
        },
        640: {
            slidesPerView: 1,
            spaceBetween: 5,
        },
        768: {
            slidesPerView: 1,
            spaceBetween: 5,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    },
    loop: true,
    // autoplay: {
    //     delay: 4000,
    //     disableOnInteraction: false,
    //     pauseOnMouseEnter: true,
    // },
    pagination: {
        el: ".swiper-pagination-news",
        clickable: true,
    },
    mousewheel: false,
    keyboard: true,
});

const swiper_supporters = new Swiper('.content-hp-sponsor-supportus .container .content-row .left .innertube .swiper', {
    preloadImages: false,
    // Enable lazy loading
    // lazy: true,
    // effect: "fade",
    // speed: 1000,
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    // pagination: {
    //     el: ".wrapper-header .wrapper-swiper-xs .container-fluid .swiper-pagination",
    //     // el: ".wrapper-header .wrapper-swiper .container-fluid .swiper .swiper-pagination",
    //     clickable: true,
    // },
    mousewheel: false,
    keyboard: true,
});

// const swiper_xs = new Swiper('.wrapper-swiper-xs .container .swiper', {
//     preloadImages: false,
//     // Enable lazy loading
//     lazy: true,
//     effect: "fade",
//     speed: 1000,
//     loop: true,
//     autoplay: {
//         delay: 4000,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//     },
//     mousewheel: false,
//     keyboard: true,
// });

// const swiper_events = new Swiper('.wrapper-swiper .container-fluid .swiper', {
//     preloadImages: false,
//     // Enable lazy loading
//     lazy: true,
//     // effect: "fade",
//     speed: 1000,
//     loop: true,
//     autoplay: {
//         delay: 4000,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//     },
//     pagination: {
//         el: ".swiper-pagination-events",
//         clickable: true,
//     },
//     mousewheel: false,
//     keyboard: true,
// });

// var swiper = new Swiper(".mixed", {
//     // fadeEffect: { crossFade: true },
//     cssMode: true,
//     autoHeight: true,
//     slidesPerView: 1,
//     // effect: "fade",
//     centeredSlides: true,
//     // spaceBetween: 15,
//     loop: true,
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//     },
//     mousewheel: true,
//     keyboard: true,
// });
// var swiper = new Swiper(".awards", {
//     cssMode: true,
//     slidesPerView: 1,
//     // centeredSlides: true,
//     loop: true,
//     spaceBetween: 5,
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//     },
//     // navigation: {
//     //     nextEl: ".swiper-button-next",
//     //     prevEl: ".swiper-button-prev",
//     // },
//     // pagination: {
//     //     el: ".swiper-pagination",
//     //     clickable: true,
//     // },
//     mousewheel: true,
//     keyboard: true,
//     // breakpoints: {
//     //     320: {
//     //         slidesPerView: 1,
//     //     },
//     //     640: {
//     //         slidesPerView: 1,
//     //     },
//     //     768: {
//     //         slidesPerView: 1,
//     //     },
//     //     1024: {
//     //         slidesPerView: 1,
//     //     },
//     //     1280: {
//     //         slidesPerView: 1,
//     //     },
//     // }
// });
// var swiper = new Swiper(".insights", {
//     cssMode: true,
//     slidesPerView: 1,
//     // centeredSlides: true,
//     loop: true,
//     spaceBetween: 5,
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//         pauseOnMouseEnter: true,
//     },
//     // navigation: {
//     //     nextEl: ".swiper-button-next",
//     //     prevEl: ".swiper-button-prev",
//     // },
//     // pagination: {
//     //     el: ".swiper-pagination",
//     //     clickable: true,
//     // },
//     mousewheel: true,
//     keyboard: true,
//     // breakpoints: {
//     //     320: {
//     //         slidesPerView: 1,
//     //     },
//     //     640: {
//     //         slidesPerView: 1,
//     //     },
//     //     768: {
//     //         slidesPerView: 1,
//     //     },
//     //     1024: {
//     //         slidesPerView: 1,
//     //     },
//     //     1280: {
//     //         slidesPerView: 1,
//     //     },
//     // }
// });
// const swiper = new Swiper('.column-left .column-row', {
//     slidesPerView: 1,
//     // spaceBetween: 0,
//     loop: true,
//     autoplay: {
//         delay: 1000,
//     },
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//         dynamicBullets: true,
//     },
//     // breakpoints: {
//     //     320: {
//     //         slidesPerView: 2,
//     //     },
//     //     640: {
//     //         slidesPerView: 3,
//     //     },
//     //     768: {
//     //         slidesPerView: 4,
//     //     },
//     //     1024: {
//     //         slidesPerView: 5,
//     //     },
//     //     1280: {
//     //         slidesPerView: 6,
//     //     },
//     // }
// });

/**
 *
 */

// var lazyLoadInstance = new LazyLoad({
//     // Your custom settings go here
// });

/**
 * Mobile Version Video
 */

// let isMobileVersion = document.getElementsByClassName("bgkvideo-xs");
// if (isMobileVersion.length > 0) {
//     isMobileVersion[0].setAttribute("playsinline", "");
//     isMobileVersion[0].setAttribute("muted", "");
// }
//
// var mobilevideo = document.getElementsByClassName("bgkvideo-xs")[0];
// mobilevideo.setAttribute("playsinline", "");
// mobilevideo.setAttribute("muted", "");


/**
 *
 */
document.addEventListener('DOMContentLoaded', function() {

    // Now you have a JavaScript object
    // console.log(entryInfo);

    // Get the object from the window object
    // const current_language = window.current_language;
    // const default_language = window.default_language;

    $(document).ready(function() {
        //Make an Ajax request to a PHP script
        //This will return the data that we can add to our Select element.

        const current_url = $('.twig-js-var').data('current_url');

        console.log(current_url);

    });

});

/**
 * Detect Mobile device
 */
let isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
    isMobile = true;
}

/**
 * Read more
 */

// let noOfCharac = 300;
// let contents = document.querySelectorAll(".abstract");
// contents.forEach(content => {
//     //If text length is less that noOfCharac... then hide the read more button
//     if(content.textContent.length < noOfCharac){
//         content.nextElementSibling.style.display = "none";
//     }
//     else{
//         let displayText = content.textContent.slice(0,noOfCharac);
//         let moreText = content.textContent.slice(noOfCharac);
//         content.innerHTML = `${displayText}<span class="dots">...</span><span class="hide more">${moreText}</span>`;
//     }
// });

// function readMore(btn){
//     let post = btn.parentElement;
//     post.querySelector(".dots").classList.toggle("hide");
//     post.querySelector(".more").classList.toggle("hide");
//     btn.textContent == "Read More" ? btn.textContent = "Read Less" : btn.textContent = "Read More";
// }
//
// document.getElementsByClassName("btnHideShow").addEventListener("click", readMore);

$('.cnt').hide();

jQuery(function(){
    // jQuery('#showall').click(function(){
    //     jQuery('.targetDiv').show();
    // });

    jQuery('.showSingle').click(function(){
        jQuery('.targetDiv').hide();

        jQuery('.cnt').show();
        jQuery('#div'+$(this).attr('target')).show();

    });
});

jQuery(function ($) {
    function AddReadMore() {
        //This limit you can set after how much characters you want to show Read More.
        var carLmt = 300;
        // Text to show when text is collapsed
        var readMoreTxt = " ...read more";
        // Text to show when text is expanded
        var readLessTxt = " read less";


        //Traverse all selectors with this class and manipulate HTML part to show Read More
        $(".add-read-more").each(function () {
            if ($(this).find(".first-section").length)
                return;

            var allstr = $(this).text();
            if (allstr.length > carLmt) {
                var firstSet = allstr.substring(0, carLmt);
                var secdHalf = allstr.substring(carLmt, allstr.length);
                var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
                $(this).html(strtoadd);
            }
        });

        //Read More and Read Less Click Event binding
        $(document).on("click", ".read-more,.read-less", function () {
            $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
        });
    }

    AddReadMore();
});

function myFunction() {
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var btnText = document.getElementById("myBtn");

    if (dots.style.display === "none") {
        dots.style.display = "inline";
        btnText.innerHTML = "Read more";
        moreText.style.display = "none";
    } else {
        dots.style.display = "none";
        btnText.innerHTML = "Read less";
        moreText.style.display = "inline";
    }
}